export const isRomScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "rom";

const JOINT_KEYS = [
  "shoulder_joint",
  "elbow_joint",
  "forearm_joint",
  "wrist_joint",
  "thumb_joint",
  "metacarpel_joint",
  "proximal_joint",
  "disital_joint",
  "hip_joint",
  "knee_joint",
  "ankle_joint",
  "foot_joint",
  "great_toe_joint",
  "inter_phalangeal_joint",
  "cervical_spine",
  "thoraco_lumbar_spine",
];

const jointHasAnyValue = (joint) => {
  if (!joint || typeof joint !== "object" || Array.isArray(joint)) return false;
  return Object.values(joint).some((v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === "string") return v.trim() !== "";
    if (typeof v === "number") return Number.isFinite(v);
    if (typeof v === "boolean") return true;
    return false;
  });
};

export const hasRomAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  return JOINT_KEYS.some((k) => jointHasAnyValue(data[k]));
};

